
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 165.001 165.001"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"shp0",attrs:{"d":"M83.4 70.2L70.2 83.4l-8.7-8.8c-2.3-2.3-5.6-3.5-9.2-3.3-5.8.3-11.6-1.7-16-6-4.2-4.2-6.2-9.7-6-15.2 0-2.3 3-3.5 4.7-1.8l5.5 5.5c2.5 2.5 6.5 2.5 9 0l4.2-4.2c2.5-2.5 2.5-6.5 0-9l-6.2-6.2c-1.7-1.7-.7-4.3 1.7-4.7 6-.7 12.3 1.3 16.8 5.8 4.7 4.7 6.5 10.8 5.8 16.8-.3 3.7.8 7.2 3.3 9.7l8.3 8.2zM133.6 113.9c0 2.3-3 3.5-4.7 1.8l-5.5-5.5c-2.5-2.5-6.5-2.5-9 0l-4.2 4.2c-2.5 2.5-2.5 6.5 0 9l6.2 6.2c1.7 1.7.7 4.3-1.7 4.7-6 .7-12.3-1.3-16.8-5.8-4.7-4.7-6.5-10.8-5.8-16.8.3-3.7-.8-7.2-3.3-9.7l-7.5-7.5 13.2-13.2 8 8.1c2.3 2.3 5.7 3.5 9.2 3.3 5.8-.3 11.7 1.7 16 6 4.1 4.2 6.1 9.7 5.9 15.2z"}}),_c('path',{staticClass:"shp0",attrs:{"d":"M79.1 104.8l-6.5-6.5 35.1-35h12.8l12.8-25.8-6.5-6.5-25.6 13.2V57L66.1 92l-6.3-6.3-25.3 25.5c-5.3 5.3-5.3 13.8 0 19.2 5.3 5.4 13.8 5.3 19.2 0l25.4-25.6z"}})])
          )
        }
      }
    